import { REQUEST_TYPES, WorkflowStatus } from "../../../../../utils/enums";

export const getRblLevelStatus = ({item, requestTypeId = null}) => {
  const rblLevel1ApproverStatusDisplay = item?.hierarchy === 1 && requestTypeId === REQUEST_TYPES.LEAVE_RECALL && item.status === WorkflowStatus.APPROVED;
  const rblLevel2ApproverStatusDisplay = item?.hierarchy === 2 && requestTypeId === REQUEST_TYPES.LEAVE_RECALL && item.status === WorkflowStatus.PENDING;

  if (rblLevel1ApproverStatusDisplay || rblLevel2ApproverStatusDisplay) {
    return WorkflowStatus.RECOMMENDED;
  }
  return item?.status ?? null;
}